import { render, staticRenderFns } from "./leaderboards.vue?vue&type=template&id=641837bc&"
import script from "./leaderboards.vue?vue&type=script&lang=js&"
export * from "./leaderboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports